import React, { useState, useEffect } from 'react';

// Dữ liệu các câu nói
const quotes = [
  { text: "To have another language is to possess a second soul.", author: "Charlemagne" },
  { text: "The limits of my language are the limits of my world.", author: "Ludwig Wittgenstein" },
  { text: "Learning another language is not only learning different words for the same things, but learning another way to think about things.", author: "Flora Lewis" },
  { text: "One language sets you in a corridor for life. Two languages open every door along the way.", author: "Frank Smith" },
  { text: "You can never understand one language until you understand at least two.", author: "Geoffrey Willans" }
];

const InspirationalQuote: React.FC = () => {
  const [quote, setQuote] = useState<{ text: string; author: string } | null>(null);

  useEffect(() => {
    // Hàm để chọn một câu nói ngẫu nhiên mới (và khác câu hiện tại)
    const changeQuote = () => {
      setQuote(currentQuote => {
        let newQuote;
        do {
          const randomIndex = Math.floor(Math.random() * quotes.length);
          newQuote = quotes[randomIndex];
        } while (newQuote.text === currentQuote?.text); // Đảm bảo câu mới không trùng câu cũ
        return newQuote;
      });
    };

    // Thay đổi câu nói ngay khi component được tải
    changeQuote();

    // Thiết lập một interval để thay đổi câu nói mỗi 30 giây
    const intervalId = setInterval(changeQuote, 10000); // 30000ms = 30s

    // Rất quan trọng: Dọn dẹp interval khi component unmount để tránh rò rỉ bộ nhớ
    return () => clearInterval(intervalId);
  }, []); // Mảng dependency rỗng `[]` để useEffect này chỉ chạy một lần lúc đầu

  if (!quote) {
    return null;
  }

  return (
    <div className="quote-container  glass-effect">
      <blockquote className="quote-text">
        "{quote.text}"
      </blockquote>
      <figcaption className="quote-author">
        &mdash; {quote.author}
      </figcaption>
    </div>
  );
};

export default InspirationalQuote;